import { FC } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { PageContainer } from '../../components/page/PageContainer';
import { PageHeader } from '../../components/page/PageHeader';
import { PageSizer } from '../../components/page/PageSizer';
import { useIntroduction } from '../../services/graph/hooks/introduction';
import strings from './site.translations';

export const NotFound: FC = () => {
  const introduction = useIntroduction();

  if (!introduction.data) {
    throw Error("Could not get image data");
  }
  
  return <PageContainer>
  <div className="w-full relative h-[300px]">
    <PageHeader title={strings.notFound.title} imageUrl={introduction.data.backgroundImages.notFoundPage}/>
    <PageSizer className="py-5 flex flex-col items-center gap-5 text-primary-800">
      <FiAlertTriangle className="h-20 w-20"/>
      <p className='text-xl max-w-md text-center'>{strings.notFound.message}</p>
    </PageSizer>
  </div>
</PageContainer>
};
